export const HOME_PAGE_TITLE = "Let's get started!";
export const PROCESSING_PAGE_TITLE = "Review application";
export const SUCCESS_PAGE_TITLE = "";
export const CODE_VERIFICATION_PAGE_TITLE = "Hello, {firstname}!";

export const TCB_BRAND_NAME = "Texas Capital Bank";
export const BASK_BRAND_NAME = "Bask Bank";

export const BASK_URL_CHECK = "baskbank";

export const SELECT_ACCOUNTS_PATH = "select-accounts";
export const HOME_PATH = "apply";
export const REVIEW_PATH = "review";
export const TERMS_AND_DISCLOSURES_PATH = "terms-and-disclosures";
export const PROCESSING_PATH = "processing";
export const BRANCH_PATH = "branch";
export const ALLOY_SDK_PATH = "alloy-sdk";
export const BANKING_CENTER_ENTRY_PATH = "banking-center";
export const BANKING_CENTER_PRODUCT_PATH = "banking-center/product";
export const STYLEGUIDE_PATH = "styleguide";
export const ERROR_PATH = "error";
export const PRODUCT_PATH = "product";
export const SUCCESS_PATH = "success";
export const CODE_VERIFICATION_PATH = "verify";
export const SOCURE_NAME = "socure";
export const MAINTENANCE_PATH = "maintenance";
export const JOINT_MAINTENANCE_PATH = 'account-holder'
export const JOINT_MAINTENANCE_PAGE_BREAK_PATH = 'account-holder/get-started';
export const JOINT_MAINTENANCE_APPLICATION_PATH = 'account-holder/add';
export const JOINT_MAINTENANCE_CREATE_LOGIN_PATH = 'account-holder/create-login';
export const INVITATION_PATH = 'account-holder/invitation';
export const INVITATION_CREATION_PATH = 'account-holder/invitation/create';
export const INVITATION_CREATION_REVIEW_PATH = 'account-holder/invitation/create/review';
export const PAGE_BREAK_PATH = 'get-started';
export const FUNDING_PATH = 'fund-account';

export const SUCCESS_TITLE_KEY = "success-title";
export const SUCCESS_NEXT_STEPS_KEY = "success-next-steps";
export const SUCCESS_HOW_TO_CONTACT_KEY = "success-how-to-contact";
export const SUCCESS_CANCEL_URL_KEY = "success-cancel-url";
export const SUCCESS_LOGIN_URL_KEY = "success-login-url";
export const SUCCESS_MESSAGE_KEY = "success-message";
export const SUCCESS_JOINT_MESSAGE_KEY = "success-joint-message";
export const SUCCESS_MESSAGE_ACCOUNT_TYPE_PLACEHOLDER = "{{accountType}}";
export const SUCCESS_MESSAGE_ACCOUNT_PLURAL_PLACEHOLDER = "{{pluralIndicator}}";
export const SUCCESS_MESSAGE_ACCOUNT_PLURAL_INDICATOR = "(s)";
export const CUSTOMER_SUPPORT_PHONE_KEY = "customer-support-phone";
export const CUSTOMER_SUPPORT_EMAIL_KEY = "customer-support-email";
export const ERROR_TITLE_KEY = "error-title";
export const APP_IN_MAINTENANCE_KEY = "app-in-maintenance";
export const SESSION_IDLE_URL_KEY = "idle-redirect-url";
export const CODE_VERIFICATION_CANCEL_REDIRECT_URL = "code-verification-cancel-redirect-url";
export const JOINT_APPLICATION_DETAILS_KEY = "joint-application-details"
export const INVITATION_LOG_KEY = "invitation-log"
export const RC_UNDER_REVIEW_PROPS_KEY = "brand.rc_underReview";
export const RC_ERROR_PROPS_KEY = "brand.rc_error";
export const RC_PRODUCT_ELIGIBILITY_ERROR_KEY = "brand.rc_product_eligibility";
export const RC_STATUS_U_ERROR_PROPS_KEY = "brand.rc_status_u_error";
export const RC_ACCOUNT_RULES_ERROR_KEY = "brand.rc_account_rules";
export const RC_JOINT_ACCOUNT_ERROR_KEY = "brand.rc_joint_account";
export const RC_HYSA_ACCOUNT_RULES_ERROR_KEY = "brand.rc_hysa_account_rules";
export const KYC_FORCE_KEY = "kyc-force";
export const TAB_CHANGE_NOTIFICATION_KEY = "tab-change-notification"

export const LETTER_KEY_CODE = "Key";
export const NUMBER_KEY_CODE = "Digit";
export const BACKSPACE_KEY_CODE = "Backspace";

export const INPUT_TAG_NAME = "INPUT";

export const LOCAL_SESSION_ID = "SessionId";
export const SESSION_ID_URL_PARAM_NAME = "sessionId";
export const SECURE_SESSION_ID_URL_PARAM_NAME = "secureSessionId";

export const TAXID_FLAG = "ssn";
export const ADDRESS_TYPE_PRIMARY = "primary";
export const PERSONAL = "personal";
export const PHONETYPE_MOBILE = "mobile";

export const SSN_APPLICANT_ERROR_KEY = "ssnNotUnique";
export const EMAIL_APPLICANT_ERROR_KEY = "emailNotUnique";
export const PHONE_APPLICANT_ERROR_KEY = "phoneNotUnique";
export const EMAIL_SSN_APPLICANT_ERROR_KEY = "emailAddress";

export const EMAIL_FORM_CONTROL = "emailAddress";
export const PHONE_FORM_CONTROL = "phoneNumber";
export const SSN_FORM_CONTROL = "ssnNumber"
export const COUNTRY_INPUT_CONTROL = "countryInput";
export const INTERNATIONAL_COUNTRY_CONTROL = "internationalCountry";
export const WIRE_INTERNATIONAL_CONTROL = "wireInternational";
export const BRANCH_ID = "branchId";
export const NETWORK_ISSUE_MESSAGE = "We are experiencing network issues. Please try again.";
export const TAXPAYER_CERTIFICATION_CHECKBOX_ID = "taxPayerCertificationCheckbox";

export const MINOR_SAVINGS_PRODUCT_NAME = "Minor Savings";
export const EMPLOYEE_CHECKING_PRODUCT_CODE = "117";
export const DEFAULT_OLB_ENROLLMENT_GROUP_ID = 26;

export const TERM_CONDITIONS_FRAME_HEIGHT_DESKTOP = 285;
export const TERM_CONDITIONS_FRAME_HEIGHT_MOBILE = 255;
export const TERM_CONDITIONS_FRAME_HEIGHT_LOW_RESOLUTION = 125;

export const TCB_BRAND_ID = 1;
export const BASK_BRAND_ID = 2;

export const EMPLOYEE_PRODUCT_EMAIL_FOR_VALIDATION = ["texascapital.com", "texascapitalbank.com"];
export const PRIMARY_APPLICANT_EMAIL = "Primary Applicant Personal Email Address";
export const CO_APPLICANT_EMAIL = "Co-Applicant Personal Email Address";
export const EMPLOYEE_PRODUCT_EMAIL_VALIDATION_MESSAGE = "Please use personal email address";

export const DEFAULT_TITLE_TERMS_AND_DISCLOSURES = "Consumer Terms and Disclosures";

export const DIGITAL_SELF_SERVE = 1;
export const BANKING_CENTER = 2;

export const ADDRESS_VALIDATION_MESSAGE = "Please enter a valid house number and street address";
export const HOUSENUMBER_VALIDATION_MESSAGE = "House number must contain a number and no special characters";
export const SSN_VALIDATION_MESSAGE = "Please enter a valid SSN.";
export const PRIMARY_APPLICANT_ADDRESS_LINE_1 = "Primary Applicant Address Line 1";
export const CO_APPLICANT_ADDRESS_LINE_1 = "Co-Applicant Address Line 1";

export const CREATE_LOGIN_PATH = "login"

export const VALID_USERNAME_API_RETRIES = 2;
export const PASSWORD_POLICY_API_RETRIES = 1;
export const DELAY_BETWEEN_API_RETRIES = 1000;

export const SUPPRESS_ACCOUNT_DETAILS = "suppressAccountDetails";
export const SUPPRESS_ACCOUNT_DETAILS_VALUE = "true";

export const APPLICATION_LOG_URL = "/leia/application/logs";

export const PRIMARY_APPLICANT_LAST_NAME = "Primary Applicant Last Name";
export const CO_APPLICANT_LAST_NAME = "Co-Applicant Last Name";

export const ALLOY_BRANCH_NAME = "persons";
export const ALLOY_ENTITY_TYPE = "person";
export const ALLOY_ANCHOR_ELEMENT = "document-capture-dialog";
export const ALLOY_VERIFICATION_OUTCOME_KEY = "document-verification-outcome";
export const ALLOY_SDK_KEY = "alloy-sdk-key";
export const ALLOY_JOURNEY_TOKEN_KEY = "alloy-journey-token";
export const ALLOY_JOURNEY_TURNOFF_MOBILE = "alloy-journey-turnoff-mobile"

export const DOCUMENT_CAPTURE_SERVICE_KEY = "document-capture-service";
export const ALLOY_SDK_PRIMARY_COLOR_KEY = "alloy-sdk-primary";
export const ALLOY_SDK_SECONDARY_COLOR_KEY = "alloy-sdk-primary";

export const EMPLOYEE_SAVINGS_PRODUCT_UID = "58916f59-ae86-4305-b2d2-91df5998e65e";
export const EMPLOYEE_SAVINGS_PRODUCT_CODE = "400";

export const TISA_INTEREST_RATE_PLAN_SUFFIX = "-irp-"

export const RC_APPLICANT_INFO_MISMATCH_ERROR_KEY = "brand.rc_applicant_info_mismatch_error";

export const ATOMIC_AVAILABLE_KEY = "direct-deposit.isAvailable";
export const FUNDING_AVAILABLE_KEY = "funding.isAvailable";

export const BSA_DETAILS_KEY = "bsa-details";
export const PRODUCT_DESCRIPTION_SETTING_KEY = "description";
export const PRODUCT_APY_TEXT_SETTING_KEY = "apy-text-override";
export const PRODUCT_TISA_URL_SETTING_KEY = "product-tisa-url";
